export enum StorageKeys {
  token = 'kattana-token',
  positions = 'kattana-positions-v1',
  account_secret = 'kattana-account_secret',
  email = 'email',
  tabs = 'kattana-tabs-v1',
  current = 'kattana-current-v1', // not used
  watchlist = 'kattana-watchlist-v1',
  tv_chart = 'kattana-tv-chart-v1',
  tv_chart_templates = 'kattana-tv-chart-v1-templates',
  tv_chart_study_templates = 'kattana-tv-chart-v1-study-templates',
  tv_chart_drawing_templates = 'kattana-tv-chart-v1-drawing-templates',
  session_id = 'kattana-session_id',
  notifications = 'notifications',
  notifications_log = 'notifications_log',
  grid = 'grid',
  previous_wallets = 'kattana-previous_wallets-v1',
  referral = 'kattana-referral-v1',
  welcomed = 'kattana-welcomed-v1',
}
